import axios from 'axios';

// Configuración base de Axios para el CRM
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 10000, // 10 segundos de timeout
});

// Flag para evitar múltiples redirects al expirar el token
let isRedirectingToLogin = false;

// Resetear el flag cuando React completa el logout (permite requests tras re-login)
export const resetAuthRedirectFlag = () => { isRedirectingToLogin = false; };

// Interceptor para agregar JWT en las requests
api.interceptors.request.use(
  (config) => {
    // Si ya estamos redirigiendo al login, cancelar nuevas requests
    if (isRedirectingToLogin) {
      const controller = new AbortController();
      controller.abort();
      return { ...config, signal: controller.signal };
    }

    const token = localStorage.getItem('colegio-token');

    if (token && config.headers) {
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor para manejar errores de respuesta
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (isRedirectingToLogin) {
      return Promise.reject(error);
    }

    // Manejo de errores globales
    if (error.response?.status === 401) {
      // Si el error es de la contraseña incorrecta en /change-password, no hacer logout
      const isPasswordError = error.config?.url?.includes('/auth/change-password') &&
                              error.response?.data?.message?.includes('contraseña actual es incorrecta');

      if (!isPasswordError) {
        // Token expirado o no válido - logout automático (una sola vez)
        isRedirectingToLogin = true;
        localStorage.removeItem('colegio-token');
        localStorage.removeItem('colegio-user');
        // Notificar a React para que haga logout limpio via AuthProvider
        // (sin window.location.href que causa loop de recargas)
        window.dispatchEvent(new Event('auth:logout'));
      }
    }

    if (error.response?.status === 403) {
      // Acceso prohibido
      console.error('Acceso prohibido - permisos insuficientes');
    }

    if (error.response?.status >= 500) {
      // Error del servidor
      const serverMessage = error.response.data?.message || '';
      if (serverMessage === 'jwt expired') {
        isRedirectingToLogin = true;
        localStorage.removeItem('colegio-token');
        localStorage.removeItem('colegio-user');
        window.dispatchEvent(new Event('auth:logout'));
      } else {
        console.error('Error del servidor:', serverMessage || 'Error interno del servidor');
      }
    }

    return Promise.reject(error);
  }
);

export default api;